
window.mr = window.mr || {};

mr = (function(mr, $, window, document) {
    "use strict";

    mr = mr || {};

    var components = {
        documentReady: [],
        documentReadyDeferred: [],
        windowLoad: [],
        windowLoadDeferred: []
    };

    mr.status = {
        documentReadyRan: false,
        windowLoadPending: false
    };

    $(document).ready(documentReady);
    $(window).on("load", windowLoad);

    function documentReady(context) {

        context = typeof context === typeof undefined ? $ : context;
        components.documentReady.concat(components.documentReadyDeferred).forEach(function(component) {
            component(context);
        });
        mr.status.documentReadyRan = true;
        if (mr.status.windowLoadPending) {
            windowLoad(mr.setContext());
        }
    }

    function windowLoad(context) {
        if (mr.status.documentReadyRan) {
            mr.status.windowLoadPending = false;
            context = typeof context === "object" ? $ : context;
            components.windowLoad.concat(components.windowLoadDeferred).forEach(function(component) {
                component(context);
            });
        } else {
            mr.status.windowLoadPending = true;
        }
    }

    mr.setContext = function(contextSelector) {
        var context = $;
        if (typeof contextSelector !== typeof undefined) {
            return function(selector) {
                return $(contextSelector).find(selector);
            };
        }
        return context;
    };

    mr.components = components;
    mr.documentReady = documentReady;
    mr.windowLoad = windowLoad;

    return mr;
}(window.mr, jQuery, window, document));

mr = (function(mr, $, window, document) {
    "use strict";

    mr.granim = mr.granim || {};

    mr.granim.documentReady = function($) {
        $('[data-gradient-bg]').each(function(index, element) {
            var granimParent = $(this),
                granimID = 'granim-' + index + '',
                colours = granimParent.attr('data-gradient-bg'),
                pairs = [],
                tempPair = [],
                ao = {},
                count,
                passes,
                i,
                themeDefaults,

                options;

            // Canvas element forms the gradient background
            granimParent.prepend('<canvas id="' + granimID + '"></canvas>');

            // Regular expression to match comma separated list of hex colour values
            passes = /^(#[0-9|a-f|A-F]{6}){1}([ ]*,[ ]*#[0-9|a-f|A-F]{6})*$/.test(colours);

            if (passes === true) {
                colours = colours.replace(' ', '');
                colours = colours.split(',');
                count = colours.length;
                // If number of colours is odd - duplicate last colour to make even array
                if (count % 2 !== 0) {
                    colours.push(colours[count - 1]);
                }
                for (i = 0; i < (count / 2); i++) {
                    tempPair = [];
                    tempPair.push(colours.shift());
                    tempPair.push(colours.shift());
                    pairs.push(tempPair);
                }

                // attribute overrides - allows per-gradient override of global options.
                ao.states = {
                    "default-state": {
                        gradients: pairs
                    }
                }
            }

            themeDefaults = {
                element: '#' + granimID,
                name: 'basic-gradient',
                direction: 'left-right',
                opacity: [1, 1],
                isPausedWhenNotInView: true,
                states: {
                    "default-state": {
                        gradients: pairs
                    }
                }
            };

            options = jQuery.extend({}, themeDefaults, mr.granim.options, ao);
            $(this).data('gradientOptions', options);
            var granimElement = $(this);
            var granimInstance = new Granim(options);
        });
    };

    mr.components.documentReadyDeferred.push(mr.granim.documentReady);
    return mr;

}(mr, jQuery, window, document));

$(document).on("turbolinks:load",function(){
	mr.documentReady(mr.setContext());    
    mr.components.documentReady.push(mr.toggleClass.documentReady);
})